<template lang="pug">
div.content
    div#new-post
        form
            ul.no-style
                li
                    input(class="input",type="text",v-model="title", placeholder="Title")
                li
                    textarea(class="textarea" v-model="text",
                    rows="50",cols="180")
                    input(type="hidden",v-model="id")
                li
                    input.button(type="button",v-on:click="SavePost",value="Save Post")
        h2 {{title}}
        div#preview.post(v-html="transformed")
</template>

<script>
import marked from 'marked';
import postService from '@/services/postsService';

marked.setOptions({
  gfm: true,
  breaks: true,
});
export default {
  name: 'Editor',
  data() {
    return {
      id: null,
      title: null,
      text: 'Type **markdown** here',
    };
  },
  computed: {
    transformed() {
      return marked(this.text);
    },
  },
  methods: {
    SavePost() {
      if (this.$route.path.indexOf('/newpost') > -1) {
        postService.$on('savePost', (res) => {
          this.$router.replace('/');
        });
        postService.savePost({ title: this.title, text: this.text });
      } else if (this.$route.path.indexOf('/editpost') > -1) {
        postService.$on('updatePost', (res) => {
          this.$router.replace('/');
        });
        postService.updatePost({ id: this.id, title: this.title, text: this.text });
      }
    },
  },
  created() {
    this.isRoute = this.$route.path.indexOf('/editpost') > -1;
    if (this.isRoute) {
      postService.$on('getPost', (post) => {
        this.text = post.text;
        this.title = post.title;
        this.id = post.id;
      });
      const post = postService.getPost(this.$route.params.id);
    }
  },
};
</script>
